import { Link } from 'wouter-preact'
import { useSignal } from '@preact/signals'
import { clsx } from 'clsx'

import {
	DownIcon,
	Input,
	Button,
	TextLink,
	Typography,
	UpIcon,
	ViewMoreButton
} from 'components'
import { SmartContract, smartContractsState } from 'state'
import { setSmartContractModalState } from 'pages/home/state'

const CreateSmartContract = () => (
	<div>
		<Typography
			color='text-black-100'
			text='Your Work'
			variant='text2'
			weight='font-bold'
		/>
		<Typography
			class='mb-2 mt-2'
			color='text-black-200'
			text='Create smart contracts that are secure, transparent in the blink of an eye.'
			variant='text2'
		/>

		<TextLink
			ariaLabel='Create Smart Contract'
			onClick={() => setSmartContractModalState(true)}
			size='small'
			text='Create Smart Contract'
		/>
	</div>
)

const LatestWorkItem = ({ dApp }: { dApp: SmartContract }) => (
	<li class='flex items-center space-x-2'>
		<div
			class={clsx(
				'flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold text-black-900'
			)}
			style={{ backgroundColor: dApp.color.default }}
		>
			{dApp.projectName[0]?.toLocaleUpperCase()}
		</div>
		<Link href={`dapp/${dApp.projectId}/smart-contract/${dApp.name}/workspace`}>
			<Typography
				class='hover:text-black-100 hover:underline'
				color='text-black-200'
				text={`${dApp.projectName}/${dApp.name}`}
				variant='text3'
			/>
		</Link>
	</li>
)

const LatestWork = () => {
	const loadMoreDApss = useSignal(false)
	const searchValue = useSignal('')

	if (smartContractsState.value.length === 0) {
		return (
			<div class='p-5'>
				<CreateSmartContract />
			</div>
		)
	}

	const filteredDApss = smartContractsState.value.filter(
		dApp =>
			dApp.projectName
				.toLowerCase()
				.includes(searchValue.value.toLowerCase()) ||
			dApp.name.toLowerCase().includes(searchValue.value.toLowerCase())
	)

	const dAppsToDisplay = filteredDApss.slice(
		0,
		loadMoreDApss.value ? smartContractsState.value.length : 5
	)

	return (
		<div class='flex flex-col overflow-hidden'>
			<div class='m-5 mb-4 flex items-center justify-between'>
				<Typography
					text='Top Smart Contracts'
					variant='h5'
					weight='font-bold'
				/>

				<Button
					onClick={() => setSmartContractModalState(true)}
					size='small'
					text='New'
				/>
			</div>

			<div class='mx-5 mb-5'>
				<Input
					id='search'
					onInput={value => {
						searchValue.value = value
					}}
					placeholder='Find a smart contract'
					size='small'
					type='text'
					value={searchValue}
				/>
			</div>

			<div class='flex-1 overflow-auto px-5 pb-5'>
				<ul class='space-y-2'>
					{dAppsToDisplay.map(dApp => (
						<LatestWorkItem dApp={dApp} key={dApp.id} />
					))}
				</ul>
				{filteredDApss.length > 5 && (
					<ViewMoreButton
						className='mt-4'
						icon={
							loadMoreDApss.value ? (
								<UpIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
							) : (
								<DownIcon className='h-2.5 w-2.5 text-black-200 group-hover:text-product' />
							)
						}
						onClick={() => {
							loadMoreDApss.value = !loadMoreDApss.value
						}}
						text={loadMoreDApss.value ? 'Load less' : 'Load more'}
					/>
				)}
			</div>
		</div>
	)
}

export { LatestWork }
